import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import H2 from 'UIComponents/elements/headings/H2';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompareErrorState = () => {
  const history = useHistory();
  const backToPricingClick = () => {
    history.push('/marketing');
  };
  return /*#__PURE__*/_jsx("div", {
    className: "text-center",
    children: /*#__PURE__*/_jsxs(UIErrorMessage, {
      illustrationProps: {
        width: 150
      },
      title: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "compare.requestStatus.FAILED.title"
        })
      }),
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "compare.requestStatus.FAILED.description"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: backToPricingClick,
        className: "m-top-8",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "compare.page.backToPricing"
        })
      })]
    })
  });
};
export default CompareErrorState;